import {createReducer} from '@reduxjs/toolkit';
import {cleanChangeRequestInfo} from 'src/modules/event-create/services/actions';
import {getChangeRequestByIdSuccess} from 'src/openapi/apis/ChangeRequestControllerApi';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';

type State = {
    data: Record<number, ChangeRequest>,
};

const defaultState = {
    data: {},
};

export const changeRequestInfo = createReducer<State>(defaultState, builder => builder
    .addCase(getChangeRequestByIdSuccess, (state, action) => {
        const changeRequest = action.payload.data;
        state.data = {...state.data, [changeRequest.id as number]: changeRequest};
    })
    .addCase(cleanChangeRequestInfo, state => {
        state.data = {};
    }),
);
